

































import { DashboardCanvas } from '@/utils/DashboardUtils';
import tiles from './tiles';
import mixins from 'vue-typed-mixins';

export default mixins().extend({
  components: {
    ...Object.entries(tiles).reduce((result: any, [key, value]) => {
      result[key] = value.component;
      return result;
    }, {}),
  },

  props: {
    canvas: {
      type: Object as () => DashboardCanvas,
    },

    params: {
      type: Object as () => any, // TODO: types
    },
  },
});
